const selector = "[data-tab]";

let els = null;

const Tabs = () => {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Loop through them
	[].forEach.call(els, function(item) {

		// Add click event listener
		item.addEventListener("click", function(e) {
			// Prevent normal clicked anchor event
			e.preventDefault();
	
			// Get clicked element
			const clickedEl = e.target;
			
			// Create new custom event "tab-clicked", which also passed id of tab
			const tabClickedEvent = new CustomEvent("tab-clicked", {
				bubbles: true,
				detail: {
					tabId: clickedEl.dataset.tab
				}
			});
	
			// Dispatch custom event
			clickedEl.dispatchEvent(tabClickedEvent);
		})
	});
}

export default Tabs;